import { render, staticRenderFns } from "./AddBalance.vue?vue&type=template&id=21f8c4f4&scoped=true&"
import script from "./AddBalance.vue?vue&type=script&lang=js&"
export * from "./AddBalance.vue?vue&type=script&lang=js&"
import style0 from "./AddBalance.vue?vue&type=style&index=0&id=21f8c4f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f8c4f4",
  null
  
)

export default component.exports